import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

export default function ForgotPasswordB2B() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('/api/b2b/forgot-password', { email });
      setDone(true);
    } catch (err) {
      // même si erreur serveur, on reste neutre côté UI
      setDone(true);
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="text-align-center" style={{ marginTop: '5rem', textAlign: 'center' }}>
        <h3>Réinitialisation</h3>
        <p>Si ce compte existe, un email de réinitialisation a été envoyé.</p>
        <Link to="/b2b-login">Retour connexion</Link>
      </div>
    );
  }

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: '65vh' }}
    >
      <form onSubmit={submit} className="form-group">
        <h3>Mot de passe oublié</h3>
        <p>Entrez votre email, vous recevrez un lien de réinitialisation.</p>

        <input
          type="email"
          placeholder="Votre email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button type="submit" disabled={loading} className="submit-btn mt-2">
          {loading ? 'Envoi...' : 'Envoyer'}
        </button>

        <div style={{ marginTop: 10 }}>
          <Link to="/b2b-login">Retour connexion</Link>
        </div>
      </form>
    </div>
  );
}
